import { app } from '../../../bootstrap/core';
import { infoIconComponent } from './infoIcon.compontent';

app.component('infoIcon', infoIconComponent);
